<template>
    <div>
        <header v-if="title" v-show="title.show">
            <h3 v-if="heading === 1" :style="{ textAlign: title.alignment, color: title.colour }">
                {{ title.text }}
            </h3>

            <h4 v-else-if="heading === 2" :style="{ textAlign: title.alignment, color: title.colour }">
                {{ title.text }}
            </h4>

            <h5 v-else-if="heading === 3" :style="{ textAlign: title.alignment, color: title.colour }">
                {{ title.text }}
            </h5>

            <h6 v-else :style="{ textAlign: title.alignment, color: title.colour }">
                {{ title.text }}
            </h6>

            <widget-description v-if="title.description" :content="title.description"/>
        </header>

        <template v-for="textArea in textAreas">
            <template v-if="textArea.position === 'top'">
                <text-extended
                    :title="textArea.title"
                    :sections="textArea.sections"
                    :fontSize="retrieveFontSize(textArea)"
                />
            </template>
        </template>

        <table :class="classes">
            <data-table-header v-if="columns" v-show="retrieveShow(columns)"
               :columns="columns"
            />

            <data-table-body
                :domain="domain"
                :tableIndex="tableIndex"
                :colspan="colspan"
                :columns="columns"
                :rows="rows"
                :limit="limit"
                :tables="tables"
                :footer="footer"
                :level="level"
                :heading="retrieveNextHeading(heading, title.show)"
                :currentQuestionId="currentQuestionId"
                :currentAnswer="currentAnswer"
            />
        </table>

        <template v-for="textArea in textAreas">
            <template v-if="textArea.position === 'bottom'">
                <text-extended
                    :title="textArea.title"
                    :sections="textArea.sections"
                    :fontSize="retrieveFontSize(textArea)"
                />
            </template>
        </template>
    </div>
</template>

<script>
    import Widget from './Widget';

    export default {
        extends: Widget,
        props: [
            'domain',
            'id',
            'tableIndex',
            'title',
            'columns',
            'colspan',
            'rows',
            'limit',
            'tables',
            'footer',
            'textAreas',
            'classes',
            'level',
            'heading',
            'currentQuestionId',
            'currentAnswer'
        ]
    }
</script>
